import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { SupportTicketServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};

const AddSupport = (data) => {
  return SupportTicketServices.addSupportTicket(data)
};
const useGetProductList = (onSuccess, onError = onDefaultError) => {
  return useQuery("product-list", SupportTicketServices.getProductList, {
    onSuccess,
    onError,
  });
};

export { AddSupport, useGetProductList };
